/**
 * Application-wide constants for TrckIt frontend
 * Centralizes magic numbers for easier maintenance and consistency
 */

// API & Network Constants
export const API_CONFIG = {
  // Retry configuration
  RETRY_DELAY_MS: 1000, // Base delay for API retries
  MAX_RETRY_DELAY_MS: 30000, // Maximum retry delay (30 seconds)
  
  // WebSocket configuration
  WS_BASE_DELAY_MS: 1000, // Base delay for WebSocket reconnection
  WS_MAX_DELAY_MS: 30000, // Maximum WebSocket reconnection delay
}

// UI Timing Constants
export const UI_TIMING = {
  // Debounce delays
  SEARCH_DEBOUNCE_MS: 300, // Debounce for search inputs
  TABLE_SEARCH_DEBOUNCE_MS: 500, // Debounce for admin table search
  
  // Animation & transitions
  POPUP_POSITION_UPDATE_MS: 700, // Delay before updating popup position
  MAP_ANIMATION_DELAY_MS: 500, // Delay for map animations
  
  // Event cleanup delays
  AUTH_EVENT_CLEANUP_MS: 100, // Cleanup delay for auth events
  CHANNEL_AUTOSELECT_RETRY_MS: 500, // Base delay for channel auto-select retries
}

// Pagination Constants
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20, // Default items per page
  MAX_PAGE_SIZE: 100, // Maximum items per page
  ANNOUNCEMENTS_PAGE_SIZE: 10, // Announcements per page
  ANNOUNCEMENTS_MAX_SIZE: 50, // Maximum announcements per page
}

// Cache & Storage Constants
export const CACHE = {
  // Gallery cache configuration
  GALLERY_CACHE_SIZE: 100, // Maximum cached gallery items
  GALLERY_CACHE_TTL_MS: 300000, // Gallery cache TTL (5 minutes)
}

// Form Validation Constants
export const VALIDATION = {
  MAX_NAME_LENGTH: 100,
  MAX_DESCRIPTION_LENGTH: 1000,
  MIN_DESCRIPTION_LENGTH: 10,
  MAX_FIRST_NAME_LENGTH: 50,
  MAX_LAST_NAME_LENGTH: 50,
  MIN_PASSWORD_LENGTH: 8,
}

// Map Constants
export const MAP_CONFIG = {
  DEFAULT_ZOOM: 14,
  MIN_ZOOM: 3,
  MAX_ZOOM: 18,
  CLUSTER_RADIUS: 50, // pixels
  NEARBY_SEARCH_RADIUS_KM: 10,
}

// WebSocket Constants
export const WEBSOCKET = {
  PING_INTERVAL_MS: 30000, // 30 seconds
  PONG_TIMEOUT_MS: 10000, // 10 seconds
  RECONNECT_BASE_DELAY_MS: 1000,
  RECONNECT_MAX_DELAY_MS: 30000,
  MAX_RECONNECT_ATTEMPTS: 10,
}

// Toast Notification Constants
export const TOAST = {
  DEFAULT_DURATION_MS: 3000,
  ERROR_DURATION_MS: 5000,
  SUCCESS_DURATION_MS: 3000,
}

// Upload Constants
export const UPLOAD = {
  MAX_FILE_SIZE_MB: 10,
  MAX_FILE_SIZE_BYTES: 10 * 1024 * 1024,
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
}

// Gamification Milestones
export const MILESTONES = [
  { id: 'first_sighting',   label: 'First Sighting',  stat: 'totalSightings',     threshold: 1 },
  { id: 'scout',            label: 'Scout',           stat: 'totalSightings',     threshold: 10 },
  { id: 'tracker',          label: 'Tracker',         stat: 'totalSightings',     threshold: 50 },
  { id: 'legend',           label: 'Legend',          stat: 'totalSightings',     threshold: 200 },
  { id: 'first_confirm',    label: 'Confirmed',       stat: 'totalConfirmations', threshold: 1 },
  { id: 'super_confirmer',  label: 'Super Confirmer', stat: 'totalConfirmations', threshold: 25 },
  { id: 'fan',              label: 'Fan',             stat: 'favoriteCount',      threshold: 5 },
  { id: 'reviewer',         label: 'Reviewer',        stat: 'totalReviews',       threshold: 3 },
]

export default {
  API_CONFIG,
  UI_TIMING,
  PAGINATION,
  CACHE,
  VALIDATION,
  MAP_CONFIG,
  WEBSOCKET,
  TOAST,
  UPLOAD,
}
